






















































import Title from '@/components/PageTitle.vue'
import { Vue, Component } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { Step } from '../store'

const bank = [
  { value: '004', name: '臺灣銀行' },
  { value: '005', name: '臺灣土地銀行' },
  { value: '006', name: '合作金庫商業銀行' },
  { value: '007', name: '第一商業銀行' },
  { value: '008', name: '華南商業銀行' },
  { value: '009', name: '彰化商業銀行' },
  { value: '011', name: '上海商業儲蓄銀行' },
  { value: '012', name: '台北富邦銀行' },
  { value: '013', name: '國泰世華銀行' },
  { value: '016', name: '高雄銀行' },
  { value: '017', name: '兆豐國際商業銀行' },
  { value: '021', name: '花旗(台灣)商業銀行' },
  { value: '050', name: '臺灣中小企業銀行' },
  { value: '053', name: '台中商業銀行' },
  { value: '081', name: '匯豐(台灣)商業銀行' },
  { value: '102', name: '華泰商業銀行' },
  { value: '103', name: '臺灣新光銀行' },
  { value: '108', name: '陽信商業銀行' },
  { value: '147', name: '三信商業銀行' },
  { value: '803', name: '聯邦商業銀行' },
  { value: '805', name: '遠東國際商業銀行' },
  { value: '806', name: '元大銀行' },
  { value: '807', name: '永豐商業銀行' },
  { value: '808', name: '玉山商業銀行' },
  { value: '809', name: '凱基銀行' },
  { value: '810', name: '星展銀行（台灣）' },
  { value: '812', name: '台新商業銀行' },
  { value: '815', name: '日盛國際商業銀行' },
  { value: '816', name: '安泰商業銀行' },
  { value: '822', name: '中國信託商業銀行' },
  { value: '960', name: '台灣樂天信用卡股份有限公司' }
]

@Component({
  components: { Title }
})
export default class WebAtm extends Vue {
  private emailHasError = false
  private bankHasError = false

  private email = ''
  private bankSelect = 'none'
  private bankOptions = bank

  private contract = false
  @Action('stepTo') stepTo !: Function
  mounted () {
    this.stepTo(Step.PaymentInput)
  }

  emailCheck () {
    this.emailHasError = !/.+@.+\..+/.test(this.email)
  }
  bankCheck () {
    this.bankHasError = this.bankSelect === 'none'
  }

  onConfirm () {
    this.emailCheck()
    this.bankCheck()
    if (this.bankHasError || this.emailHasError) {
      return false
    }
    this.$router.push('/finish')
  }
}
